import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import ReturnPolicy from "../components/returnPolicy/ReturnPolicy";
import ReturnPolicyHero from "../components/returnPolicy/ReturnPolicyHero";
import { Header, Footer } from "../shared";

const ReturnPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <ReturnPolicyHero />
      <ReturnPolicy />
      <Footer />
    </div>
  );
};

export default ReturnPolicyPage;
